define([
    'text!product-detail/ymb/ymb-leg-slick.html',
    'WebCommon/mixin/slick',
    'common/utils',
    'css!product-detail/ymb/ymb-leg-slick.css'
], function(
    tpl,
    SlickMixin,
    Utils
){
    return {
        template: tpl,
        mixins: [SlickMixin],
        methods: {
            genFurnitureDetailLink: Utils.genFurnitureDetailLink
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/ymb/ymb-leg-slick.js
// module id = 295
// module chunks = 0